<template>
  <section :id="$style.all_score">
    <main-title
      :class="$style.title"
      :main_title="'全記録'"
      :sub_title="'All score'"
      :color="'#403f3f'"
      :align="'center'"
    ></main-title>

    <div :class="$style.side_scroll_table">
      <table :id="$style.alldata">
        <tr :class="$style.thead">
          <th>
            <br />
          </th>
          <th>試合</th>
          <th>打席</th>
          <th>打数</th>
          <th>得点</th>
          <th>安打</th>
          <th>二塁打</th>
          <th>三塁打</th>
          <th>本塁打</th>
          <th>塁打</th>
          <th>打点</th>
          <th>盗塁</th>
          <th>犠飛</th>
          <th>四球</th>
          <th>死球</th>
          <th>三振</th>
          <th>打率</th>
          <th>長打率</th>
          <th>出塁率</th>
          <th>打数/本</th>
          <th>打撃妨害</th>
        </tr>
        <tr>
          <th :class="$style.year_thead">1993</th>
          <td>57</td>
          <td>203</td>
          <td>184</td>
          <td>27</td>
          <td>41</td>
          <td>9</td>
          <td>0</td>
          <td>11</td>
          <td>83</td>
          <td>27</td>
          <td>1</td>
          <td>0</td>
          <td>17</td>
          <td>2</td>
          <td>50</td>
          <td>.223</td>
          <td>.451</td>
          <td>.296</td>
          <td>16.7</td>
          <td>-</td>
        </tr>

        <tr>
          <th :class="$style.year_thead">1994</th>
          <td>130</td>
          <td>569</td>
          <td>503</td>
          <td>70</td>
          <td>148</td>
          <td>23</td>
          <td>4</td>
          <td>20</td>
          <td>239</td>
          <td>66</td>
          <td>6</td>
          <td>4</td>
          <td>57</td>
          <td>4</td>
          <td>101</td>
          <td>.294</td>
          <td>.475</td>
          <td>.367</td>
          <td>25.1</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">1995</th>
          <td>131</td>
          <td>569</td>
          <td>501</td>
          <td>76</td>
          <td>142</td>
          <td>31</td>
          <td>1</td>
          <td>22</td>
          <td>241</td>
          <td>80</td>
          <td>9</td>
          <td>2</td>
          <td>62</td>
          <td>2</td>
          <td>93</td>
          <td>.283</td>
          <td>.481</td>
          <td>.362</td>
          <td>22.8</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">1996</th>
          <td>130</td>
          <td>569</td>
          <td>487</td>
          <td :class="$style.best">97</td>
          <td>153</td>
          <td>34</td>
          <td>1</td>
          <td>38</td>
          <td :class="$style.best">303</td>
          <td>99</td>
          <td>7</td>
          <td>7</td>
          <td>71</td>
          <td>4</td>
          <td>98</td>
          <td>.314</td>
          <td>.622</td>
          <td>.400</td>
          <td>12.8</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">1997</th>
          <td>135</td>
          <td>596</td>
          <td>484</td>
          <td>93</td>
          <td>144</td>
          <td>18</td>
          <td>0</td>
          <td>37</td>
          <td>273</td>
          <td>103</td>
          <td>9</td>
          <td>6</td>
          <td :class="$style.best">100</td>
          <td>6</td>
          <td>84</td>
          <td>.298</td>
          <td>.564</td>
          <td>.419</td>
          <td>13.1</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">1998</th>
          <td>135</td>
          <td>603</td>
          <td>487</td>
          <td :class="$style.best">103</td>
          <td>142</td>
          <td>24</td>
          <td>3</td>
          <td :class="$style.best">34</td>
          <td>274</td>
          <td :class="$style.best">100</td>
          <td>3</td>
          <td>4</td>
          <td :class="$style.best">104</td>
          <td :class="$style.best">8</td>
          <td>101</td>
          <td>.292</td>
          <td :class="$style.best">.563</td>
          <td :class="$style.best">.421</td>
          <td>14.3</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">1999</th>
          <td>135</td>
          <td>573</td>
          <td>471</td>
          <td>100</td>
          <td>143</td>
          <td>24</td>
          <td>2</td>
          <td>42</td>
          <td>297</td>
          <td>95</td>
          <td>0</td>
          <td>6</td>
          <td>93</td>
          <td>2</td>
          <td>99</td>
          <td>.304</td>
          <td>.631</td>
          <td>.416</td>
          <td>11.2</td>
          <td>1</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2000</th>
          <td>135</td>
          <td>590</td>
          <td>474</td>
          <td :class="$style.best">116</td>
          <td>150</td>
          <td>32</td>
          <td>1</td>
          <td :class="$style.best">42</td>
          <td :class="$style.best">310</td>
          <td :class="$style.best">108</td>
          <td>5</td>
          <td :class="$style.best">7</td>
          <td :class="$style.best">106</td>
          <td>2</td>
          <td>108</td>
          <td>.316</td>
          <td :class="$style.best">.654</td>
          <td :class="$style.best">.438</td>
          <td>11.3</td>
          <td>1</td>
        </tr>

        <tr>
          <th :class="$style.year_thead">2001</th>
          <td>140</td>
          <td>611</td>
          <td>481</td>
          <td :class="$style.best">107</td>
          <td>160</td>
          <td>23</td>
          <td>3</td>
          <td>36</td>
          <td :class="$style.best">297</td>
          <td>104</td>
          <td>3</td>
          <td>7</td>
          <td>120</td>
          <td>3</td>
          <td>96</td>
          <td :class="$style.best">.333</td>
          <td>.617</td>
          <td>.463</td>
          <td>13.4</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2002</th>
          <td>140</td>
          <td>623</td>
          <td>500</td>
          <td :class="$style.best">112</td>
          <td>167</td>
          <td>27</td>
          <td>1</td>
          <td :class="$style.best">50</td>
          <td :class="$style.best">346</td>
          <td :class="$style.best">107</td>
          <td>3</td>
          <td>3</td>
          <td :class="$style.best">114</td>
          <td>6</td>
          <td>104</td>
          <td>.334</td>
          <td :class="$style.best">.692</td>
          <td :class="$style.best">.461</td>
          <td>10.0</td>
          <td>-</td>
        </tr>
        <tr :class="$style.total">
          <th :class="$style.year_thead">日本通算</th>
          <td>1268</td>
          <td>5506</td>
          <td>4572</td>
          <td>901</td>
          <td>1390</td>
          <td>245</td>
          <td>16</td>
          <td>332</td>
          <td>2663</td>
          <td>889</td>
          <td>46</td>
          <td>46</td>
          <td>844</td>
          <td>39</td>
          <td>934</td>
          <td>.304</td>
          <td>.582</td>
          <td>.413</td>
          <td>13.7</td>
          <td>2</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2003</th>
          <td>163</td>
          <td>695</td>
          <td>623</td>
          <td>82</td>
          <td>179</td>
          <td>42</td>
          <td>1</td>
          <td>16</td>
          <td>271</td>
          <td>106</td>
          <td>2</td>
          <td>6</td>
          <td>63</td>
          <td>3</td>
          <td>86</td>
          <td>.287</td>
          <td>.435</td>
          <td>.353</td>
          <td>38.9</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2004</th>
          <td>162</td>
          <td>680</td>
          <td>584</td>
          <td>109</td>
          <td>174</td>
          <td>34</td>
          <td>2</td>
          <td>31</td>
          <td>305</td>
          <td>108</td>
          <td>3</td>
          <td>5</td>
          <td>88</td>
          <td>3</td>
          <td>103</td>
          <td>.298</td>
          <td>.522</td>
          <td>.390</td>
          <td>18.8</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2005</th>
          <td>162</td>
          <td>704</td>
          <td>629</td>
          <td>108</td>
          <td>192</td>
          <td>45</td>
          <td>3</td>
          <td>23</td>
          <td>312</td>
          <td>116</td>
          <td>2</td>
          <td>8</td>
          <td>63</td>
          <td>3</td>
          <td>78</td>
          <td>.305</td>
          <td>.496</td>
          <td>.367</td>
          <td>27.3</td>
          <td>1</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2006</th>
          <td>51</td>
          <td>201</td>
          <td>172</td>
          <td>32</td>
          <td>52</td>
          <td>9</td>
          <td>0</td>
          <td>8</td>
          <td>85</td>
          <td>29</td>
          <td>1</td>
          <td>2</td>
          <td>27</td>
          <td>0</td>
          <td>23</td>
          <td>.302</td>
          <td>.494</td>
          <td>.393</td>
          <td>21.5</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2007</th>
          <td>143</td>
          <td>634</td>
          <td>547</td>
          <td>100</td>
          <td>156</td>
          <td>28</td>
          <td>4</td>
          <td>25</td>
          <td>267</td>
          <td>103</td>
          <td>4</td>
          <td>10</td>
          <td>73</td>
          <td>3</td>
          <td>73</td>
          <td>.285</td>
          <td>.488</td>
          <td>.367</td>
          <td>21.9</td>
          <td>1</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2008</th>
          <td>93</td>
          <td>378</td>
          <td>337</td>
          <td>43</td>
          <td>99</td>
          <td>17</td>
          <td>0</td>
          <td>9</td>
          <td>143</td>
          <td>45</td>
          <td>0</td>
          <td>0</td>
          <td>38</td>
          <td>3</td>
          <td>47</td>
          <td>.294</td>
          <td>.424</td>
          <td>.370</td>
          <td>37.4</td>
          <td>-</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2009</th>
          <td>142</td>
          <td>528</td>
          <td>456</td>
          <td>62</td>
          <td>125</td>
          <td>21</td>
          <td>1</td>
          <td>28</td>
          <td>232</td>
          <td>90</td>
          <td>0</td>
          <td>2</td>
          <td>64</td>
          <td>4</td>
          <td>75</td>
          <td>.274</td>
          <td>.509</td>
          <td>.367</td>
          <td>16.2</td>
          <td>2</td>
        </tr>

        <tr>
          <th :class="$style.year_thead">2010</th>
          <td>145</td>
          <td>558</td>
          <td>482</td>
          <td>55</td>
          <td>132</td>
          <td>24</td>
          <td>1</td>
          <td>21</td>
          <td>221</td>
          <td>84</td>
          <td>0</td>
          <td>4</td>
          <td>67</td>
          <td>1</td>
          <td>98</td>
          <td>.274</td>
          <td>.459</td>
          <td>.366</td>
          <td>22.9</td>
          <td>4</td>
        </tr>

        <tr>
          <th :class="$style.year_thead">2011</th>
          <td>141</td>
          <td>584</td>
          <td>517</td>
          <td>58</td>
          <td>130</td>
          <td>28</td>
          <td>0</td>
          <td>12</td>
          <td>194</td>
          <td>72</td>
          <td>1</td>
          <td>9</td>
          <td>56</td>
          <td>1</td>
          <td>84</td>
          <td>.251</td>
          <td>.375</td>
          <td>.321</td>
          <td>43.0</td>
          <td>1</td>
        </tr>
        <tr>
          <th :class="$style.year_thead">2012</th>
          <td>34</td>
          <td>103</td>
          <td>95</td>
          <td>7</td>
          <td>14</td>
          <td>1</td>
          <td>0</td>
          <td>2</td>
          <td>21</td>
          <td>7</td>
          <td>0</td>
          <td>0</td>
          <td>8</td>
          <td>0</td>
          <td>22</td>
          <td>.147</td>
          <td>.221</td>
          <td>.214</td>
          <td>47.5</td>
          <td>0</td>
        </tr>

        <tr :class="$style.total">
          <th :class="$style.year_thead">MLB通算</th>
          <td>1236</td>
          <td>5065</td>
          <td>4442</td>
          <td>656</td>
          <td>1253</td>
          <td>249</td>
          <td>12</td>
          <td>175</td>
          <td>2051</td>
          <td>760</td>
          <td>13</td>
          <td>46</td>
          <td>547</td>
          <td>21</td>
          <td>689</td>
          <td>.282</td>
          <td>.461</td>
          <td>.360</td>
          <td>25.3</td>
          <td>9</td>
        </tr>
        <tr :class="$style.total">
          <th :class="$style.year_thead">日米通算</th>
          <td>2504</td>
          <td>10571</td>
          <td>9014</td>
          <td>1557</td>
          <td>2643</td>
          <td>494</td>
          <td>28</td>
          <td>507</td>
          <td>4714</td>
          <td>1649</td>
          <td>59</td>
          <td>92</td>
          <td>1391</td>
          <td>60</td>
          <td>1623</td>
          <td>.293</td>
          <td>.522</td>
          <td>.387</td>
          <td>17.7</td>
          <td>11</td>
        </tr>
      </table>
    </div>
  </section>
</template>

<script lang="ts">
import Vue from "vue";
import MainTitle from "@/components/atoms/MainTitle.vue";

export default Vue.extend({
  name: "AllScoreVisual",

  components: {
    MainTitle
  }
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #all_score {
    .title {
      margin-bottom: 30px;
    }

    // https://b-risk.jp/blog/2018/07/table-css/
    // table {
    //   width: 80%;
    // }
    // table .thead {
    //   display: none;
    // }
    // table tr {
    //   width: 100%;
    // }
    // table td {
    //   display: block;
    //   text-align: right;
    //   width: 100%;
    // }
    // table .year_thead {
    //   background: #e9727e;
    //   color: #fff;
    //   font-weight: bold;
    //   text-align: center;
    // }
    // table td:before {
    //   content: attr(data-label);
    //   float: left;
    //   font-weight: bold;
    //   margin-right: 10px;
    // }
    .side_scroll_table {
      overflow: auto;
      overflow-y: hidden;
      #alldata {
        margin: auto;
        width: 90%;
        min-width: 650px;
        font-size: 12px;
        border-collapse: collapse;
        border: 1px solid #aaaaaa;
        th,
        td {
          padding: 7px 1px;
          text-align: center;
        }
        th {
          background-color: #007bbb;
          color: #fff;
          border-left: 1px solid #eff7ff;
          border-bottom: 1px solid #eff7ff;
        }
        td {
          background-color: #eff7ff;
        }
        .best {
          color: red;
        }
        .total {
          td {
            background-color: #c6e2ff;
          }
        }
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #all_score {
    .title {
      margin-bottom: 30px;
      text-align: center;
    }

    #alldata {
      margin: auto;
      width: 900px;
      font-size: 12px;
      border-collapse: collapse;
      border: 1px solid #aaaaaa;
      th,
      td {
        padding: 7px 3px;
        text-align: center;
      }
      th {
        background-color: #007bbb;
        color: #fff;
        border-left: 1px solid #eff7ff;
        border-bottom: 1px solid #eff7ff;
      }
      td {
        background-color: #eff7ff;
      }
      .best {
        color: red;
      }
      .total {
        td {
          background-color: #c6e2ff;
        }
      }
    }
  }
}
</style>
